export default __webpack_public_path__ + "static/media/Email.6cd5d6e1.svg";